import { compactClassName } from '@/components/homepage-october/compact'
import * as React from 'react'

import { cn } from '@/lib/utils'

// The three icons that repeat on every card and link row (the save heart, the rating stars and the → arrow, about
// 600 copies) are each one <span>: its shape is a CSS mask of lucide-react 1.47.0's path (app.css, .v3-ic-*), painted
// in currentColor, so colour, hover and size-* classes work as on a lucide icon. One element per icon instead of the
// two of a sprite <use> or the three of an inline <svg>; a rating's five stars are one element per layer.
type Props = React.HTMLAttributes<HTMLSpanElement>

function icon(shape: string, name: string) {
  function Icon({ className, 'aria-hidden': _decorative, ...rest }: Props) {
    return <span {...rest} className={compactClassName(cn('v3-icon', shape, className))} />
  }
  Icon.displayName = name
  return Icon
}

/** Same uses as lucide-react's ArrowRight, Heart and Star. */
export const ArrowRight = icon('v3-ic-arrow', 'ArrowRight')
export const Heart = icon('v3-ic-heart', 'Heart')
export const Star = icon('v3-ic-star', 'Star')

/** Five stars in one element (the mask repeats). A second copy, with `width` as a percentage, is the filled layer. */
export function StarRow({ className, 'aria-hidden': _decorative, ...rest }: Props) {
  return <span {...rest} className={compactClassName(cn('v3-icon v3-ic-stars', className))} />
}
